@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.error-container {
  display: flex;
  align-items: center;
  padding: 5px 10px 5px 5px;
  border-radius: 5px;
  background-color: @fulfillment-planner--container--error--background-color;
  color: @fulfillment-planner--container--error--text-color;
  fill: @fulfillment-planner--container--error--fill-color;

  .column-of-errors {
    > * {
      margin-top: 5px;
    }
  }

  .message-style:not(:first-child) {
    padding-top: 10px;
  }
}
